import { render, staticRenderFns } from "./inspeccionTabs.vue?vue&type=template&id=d0a8e890&"
import script from "./inspeccionTabs.vue?vue&type=script&lang=js&"
export * from "./inspeccionTabs.vue?vue&type=script&lang=js&"
import style0 from "./inspeccionTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports